import { faAngleLeft, faAngleRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";

function Paginator({ page = 2, perPage = 10000, hasMore = true, next, prev }) {
  return (
    <Container>
      {page > 1 && (
        <Button
          onClick={() => {
            window.scrollTo(0, 0);
            prev && prev();
          }}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </Button>
      )}
      {hasMore && (
        <Button
          onClick={() => {
            window.scrollTo(0, 0);
            next && next();
          }}
        >
          <FontAwesomeIcon icon={faAngleRight} />
        </Button>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
`;

const Button = styled.div`
  display: inline-block;
  padding: 2px 10px;
  background-color: #dddddd;
  color: white;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #d5d5d5;
  }
`;

export default Paginator;
